import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Swal from 'sweetalert2'
import axios from 'axios'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import DateFnsUtils from '@date-io/date-fns';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Modal from '@material-ui/core/Modal';
import Checkbox from '@material-ui/core/Checkbox';


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    paperModal: {
        position: 'absolute',
        width: 500,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    input: {
        marginTop: '3%'
    },
    root: {
        marginTop: '2%'
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    typography: {
        marginTop: '5%'
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    containerTextHeader: {
        justifyContent: 'space-between',
        alignItems: 'center',
        display: 'flex'
    },
    endYear: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
}));

async function onSubmitWorking(participantId, companyName, position, lokasi, salary, startYear, endYear, summary, open, setOpen, working, setWorking) {
    let array = [companyName, position, lokasi, salary, startYear, summary]

    for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element == null || element == '') {
            return alert('Lengkapi data mu')
        }
    }

    Swal.showLoading()
    axios.post(`${process.env.REACT_APP_API}/participant/biodata/working`, {
        participant_id: participantId,
        company_name: companyName,
        position: position,
        location: lokasi,
        salary: salary,
        year_start: startYear,
        year_end: endYear,
        summary: summary
    })
        .then(function (response) {
            Swal.close()
            setOpen(false)
            let obj = {
                company_name: companyName,
                position: position,
                location: lokasi,
                salary: salary,
                year_start: startYear,
                year_end: endYear,
                summary: summary
            }
            setWorking([...working, obj])
            // history.push({
            //     pathname: '/biodata/working',
            //     state: { participantId: biodata.participantId, name: biodata.fullname }
            // })
        })
        .catch(function (error) {
            Swal.close()
            return Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error
            })
        })
}

function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}


function getWorking(workingExperiences, setWorking) {
    return workingExperiences ? setWorking(workingExperiences) : null
}

export default function WorkingProfile(participantId, working, setWorking) {
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);
    const [open, setOpen] = React.useState(false);
    const [checked, setChecked] = React.useState(false);
    const [companyName, setCompanyName] = useState('')
    const [position, setPosition] = useState('')
    const [lokasi, setLokasi] = useState('')
    const [salary, setSalary] = useState('')
    const [startYear, setStartYear] = useState('')
    const [endYear, setEndYear] = useState('')
    const [summary, setSummary] = useState('')

    const handleOpen = () => {
        setCompanyName('')
        setPosition('')
        setLokasi('')
        setSalary('')
        setStartYear('')
        setEndYear('')
        setSummary('')
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (event) => {
        setEndYear(null)
        setChecked(event.target.checked);
    };

    const body = (
        <div style={modalStyle} className={classes.paperModal}>
            <Typography variant="subtitle1">
                ADD WORKING EXPERIENCE
            </Typography>
            <TextField
                variant="outlined"
                required
                fullWidth
                id="company_name"
                label="Company Name"
                name="company_name"
                autoComplete="company_name"
                className={classes.input}
                onChange={e => setCompanyName(e.target.value)}
                value={companyName}
                size="small"
            />

            <TextField
                variant="outlined"
                required
                fullWidth
                id="position"
                label="Position"
                name="position"
                autoComplete="position"
                className={classes.input}
                onChange={e => setPosition(e.target.value)}
                value={position}
                size="small"
            />

            <TextField
                variant="outlined"
                required
                fullWidth
                id="location"
                label="Location"
                name="location"
                autoComplete="location"
                className={classes.input}
                onChange={e => setLokasi(e.target.value)}
                value={lokasi}
                size="small"
            />

            <TextField
                variant="outlined"
                required
                fullWidth
                id="salary"
                label="Salary"
                name="salary"
                autoComplete="salary"
                className={classes.input}
                onChange={e => setSalary(e.target.value)}
                value={salary}
                size="small"
            />

            <TextField
                variant="outlined"
                required
                fullWidth
                id="start_year"
                label="Start Year"
                name="start_year"
                autoComplete="start_year"
                className={classes.input}
                onChange={e => setStartYear(e.target.value)}
                value={startYear}
                size="small"
            />
            <div className={classes.endYear}>
                <TextField
                    variant="outlined"
                    required
                    id="end_year"
                    label="End Year"
                    name="end_year"
                    autoComplete="end_year"
                    className={classes.input}
                    style={{ width: '50%' }}
                    onChange={e => setEndYear(e.target.value)}
                    value={endYear}
                    size="small"
                />
                OR
                <Checkbox
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                    size="small"
                />
                Present
            </div>

            <TextField
                id="outlined-multiline-static"
                label="Summary"
                multiline
                fullWidth
                rows={4}
                variant="outlined"
                className={classes.input}
                onChange={e => setSummary(e.target.value)}
                value={summary}
                size="small"
            />

            <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() => onSubmitWorking(participantId, companyName, position, lokasi, salary, startYear, endYear, summary, open, setOpen, working, setWorking)}
            >
                SAVE
            </Button>
        </div>
    );

    return (
        <div>
            <div className={classes.containerTextHeader}>
                <Typography variant="subtitle1">
                    Working Experience
    </Typography>
                <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={handleOpen}
                >
                    Add
    </Button>
            </div>
            {
                working.length !== 0 ?
                    working.map((value, index) => {
                        return (
                            <Card className={classes.root} variant="outlined">
                                <CardContent>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        {value.company_name}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        {value.year_start} - {value.year_end === null ? 'Present' : value.year_end}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        {value.location}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        {value.position}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        {value.summary}
                                    </Typography>
                                </CardContent>
                            </Card>
                        )
                    })
                    : null
            }

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    )
}